const ModalContent = () => {
  return (
    <>
      <p>Rất tiếc, bạn không đủ điều kiện để mua combo của Galaxy Play.</p>
      <p>Vui lòng dùng số điện thoại khác</p>
    </>
  );
};
export default ModalContent;
